import React from 'react';

import { Nullable } from '@clearverify/types';

import { PeoOrderBy, PeoWhere, usePeosListQuery } from 'src/api';
import { PaginationQueryVariables } from 'src/hooks/common';

export const usePeosList = (
  filter: PeoWhere,
  sort: Nullable<PeoOrderBy>,
  paginationVariables: PaginationQueryVariables,
  notifyOnNetworkStatusChange?: boolean,
) => {
  const { data, loading, refetch } = usePeosListQuery({
    variables: {
      filter,
      orderBy: sort,
      ...paginationVariables,
    },
    notifyOnNetworkStatusChange,
  });

  const peosList = React.useMemo(() => {
    return data?.peoList ?? [];
  }, [data?.peoList]);

  const peosCount = React.useMemo(() => {
    return data?.peoCount || 0;
  }, [data?.peoCount]);

  return {
    peosList,
    peosCount,
    loading,
    refetch,
  };
};
